import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { type ConsentCode } from "../constants/consentCode"

const consentFragment = graphql(`
    fragment isAcceptedConsent_Consent on ConsentType {
        code
        value
    }
`)

export function isAcceptedConsent(fragment: FragmentOf<typeof consentFragment>, code: ConsentCode) {
    const consent = readFragment(consentFragment, fragment)

    return consent.code === code && consent.value === "ACCEPTED"
}

isAcceptedConsent.fragments = { consent: consentFragment }
